import type { SxProps, Theme } from "@mui/material/styles";

export const primaryAction: SxProps<Theme> = {
  px: 4,
};

// The theme makes every Button a full-width contained one; the secondary action is a quiet link.
export const linkAction: SxProps<Theme> = {
  px: 2,
  boxShadow: "none",
  color: "text.secondary",
  "&:hover": { bgcolor: "action.hover", boxShadow: "none", color: "primary.main" },
  "&:active": { boxShadow: "none" },
};
